// extracted by mini-css-extract-plugin
export default {"skeleton":"DrawerSkeleton_skeleton__+AU7+","shimmer":"DrawerSkeleton_shimmer__3HW-h"};